export default "__VITE_ASSET__ee41b9c6__"